import BookingWidget from './booking';
import CalendarWidget from './calendar';

export default function ($) {
  /**
   * Booking widget close button
   * @type {string}
   */
  const buttonCloseEl = '.booking-widget__close .c-cross';
  const buttonCloseElCalendar = '.booking-calendar-widget__close';
  const widgetTitle = '.js-booking-widget-title';
  const tab = '.js-booking-tab';

  /**
   * Booking widget hash.
   *
   * Should be the same as:
   *  -  web/app/themes/azds-default/templates/partial/book-button.twig
   *  -  web/app/themes/azds-default/templates/partial/book-link.twig
   * bookURL by default
   *
   * @type {string[]}
   */
  const bookingWidgetHash = ['#booking-stay', '#booking-gather', '#booking-table', '#booking-spa', '#booking-golf'];

  /**
   * Get tab from hash
   * @param {string} hash
   * @returns {string}
   */
  function getTab(hash) {
    return hash.replace('#booking-', '');
  }

  /**
   * Booking widget open by hash
   */
  $(window).on('load', () => {
    if (bookingWidgetHash.includes(window.location.hash)) {
      BookingWidget.open(getTab(window.location.hash));
    }

    $(tab).on('shown.bs.tab', (event) => {
      const current = event.target.getAttribute('id');
      const $bookingTitleElement = $(widgetTitle);
      const title = $bookingTitleElement.data('titles')[current];

      $bookingTitleElement.fadeOut(100, () => {
        $bookingTitleElement.html(title);
        $bookingTitleElement.fadeIn(200);
      });
    });
  });

  /**
   * Booking widget open
   */
  $(document).on('click tap', 'a', (event) => {
    let href = $(event.target).prop('href');

    if (!href) {
      href = $(event.target).closest('a').prop('href');
    }

    if (!href) {
      return false;
    }

    const url = new URL(href);

    if (url.hash.length) {
      const hasBooking = bookingWidgetHash.filter((el) => url.hash.indexOf(el) !== -1).length > 0;

      if (hasBooking) {
        return BookingWidget.open(getTab(url.hash));
      }
    }

    return true;
  });

  /**
   * Booking widget open (native button trigger)
   */
  $(document).on('click tap', '[aria-haspopup="dialog"][aria-controls="booking-widget"]', (event) => {
    event.preventDefault();
    BookingWidget.open($(event.currentTarget).data('bookingTab'));
  });

  /**
   * Booking widget close
   */
  $(document).on('click tap', buttonCloseEl, () => {
    BookingWidget.close();
  });

  /**
   * Booking calendar widget open
   */
  $(document).on('click tap', '.booking-calendar__open', (event) => {
    if ($(event.target).attr('id') === 'table_show_date') {
      $('.booking-calendar-widget__content .daterangepicker.stay-picker').hide();
      $('.booking-calendar-widget__content .daterangepicker.table-picker').show();
    }

    if ($(event.target).attr('id') === 'check-in') {
      $('.booking-calendar-widget__content .daterangepicker.table-picker').hide();
      $('.booking-calendar-widget__content .daterangepicker.stay-picker').show();
    }

    CalendarWidget.open();
  });

  /**
   * Booking calendar widget close
   */
  $(document).on('click tap', buttonCloseElCalendar, () => {
    CalendarWidget.close();
  });

  $(document).on('keyup', '.booking-calendar__open, .js-input-filter', (event) => {
    if (event.code === 'Space') {
      event.target.click();
    }
  });

  $(document).on('keyup', '#guestsNo', (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
  });

  $(document).on('keyup', '#roomsNo', (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
  });

  document.body.addEventListener('overlay:hide', () => { BookingWidget.close(); CalendarWidget.close(); });
}
